<template lang="pug">
#drawingAlignModel
  #modelMap.comAll(v-dragDiv, v-show='!operShow&&!actionData.isMini')
    .title.moveDragDiv
      span {{ actionData.cnName }}
      el-button(plain,size="mini",type="primary",v-if="loadList.length>0" @click="changeOper") 操作
      i.el-icon-minus.minibtn(title='最小化', @click='miniCom')
      i.el-icon-close(title='关闭', @click='closeAdd')
    .nav
      el-input(placeholder='请输入图纸名称', size='mini', suffix-icon='el-icon-search', v-model='mapName')
    .list
      el-table(ref='mapTable', border, :data="mapList",@select='selectMap')
        el-table-column(type='selection' width='55')
        el-table-column(prop='drawName' label='图纸名称'  align='center')
        el-table-column(label='缩略图' width='150' align='center')
          template(slot-scope='{row}')
            viewer(:images="[row.downloadUrl]")
              img(:src='row.downloadUrl',style="width: 50px; height: 50px", alt='图纸缩略图')
  #modelMapMini(v-if="operShow")
    .title
      span {{actionData.cnName}}
      el-button(size='mini' type='primary' @click='changeOper') 最大化
      i.el-icon-close.closebtn(title='关闭' @click='closeAdd')
    .tableMin
      el-table(ref='minTable',border,:data="loadList")
        el-table-column(prop='drawName' label='图纸名称' )
        el-table-column(prop='drawName' label='操作' width="220")
          template(slot-scope='{row}')
            el-slider.verSlider(v-model='row.sliderLocation', :min='min', :step='0.1', :max='max', @input='sectionLocation(row)')
</template>

<script>
import mongeApiMlib from '@/CommonDP/mongeView/mongeApiMlib';
import mongeService from '@/CommonDP/mongeView/service/monge-service';
import { mongeApp } from '@/CommonDP/mongeView/store/mongeStore';
import { v4 as uuidv4 } from 'uuid';
import Vue from "vue";
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      mapName: '',
      groupPics: [],
      loadList: [],
      drawingList: [],
      operShow: false
    };
  },
  computed: {
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    mapList() {
      if (this.mlibEnabled) {
        return this.groupPics.filter(e => e.drawName?.includes(this.mapName));
      } else {
        return this.groupPics.filter(e => decodeURIComponent(e.picName)?.includes(this.mapName));
      }
    },
    max() {
      return Math.floor(this.maxValue()?.z);
    },
    min() {
      return Math.floor(this.minValue()?.z);
    }
  },
  mounted() {
    this.loadMapList();
  },
  methods: {
    loadMapList() {
      this.groupPics = [];
      if (this.mlibEnabled) {
        this.isOssMap();
      } else {
        this.commMap();
      }
    },
    async isOssMap() {
      const models = await mongeApiMlib.getModels();
      let modelAttrList = [];
      models.forEach(element => {
        const bimexDetailList = element.url?.bimexDetailList;
        const array = bimexDetailList.map(i => {
          return { ...i, modelId: element.id };
        });
        modelAttrList = [...modelAttrList, ...array];
      });
      this.groupPics = modelAttrList.filter(ele => ele.label === '2D-IMG').map(e => {
        return {
          ...e,
          uuid: uuidv4()
        };
      });
    },
    commMap() {
      if (this.modelInfoData.fileObj) {
        // 多文件
        this.multiMaps();
      } else if (this.modelInfoData.fileId) {
        // 单文件
        this.singleMap();
      }
    },
    async multiMaps() {
      for (const iterator of this.modelInfoData.fileObj) {
        await this.getDwgList(iterator.folderID, iterator.rvtVersion);
      }
    },
    singleMap() {
      const fileId = this.modelInfoData.fileId;
      const rvtVersion = this.modelInfoData.rvtVersion || '';
      this.getDwgList(fileId, rvtVersion);
    },
    async getDwgList(fileId, rvtVersion) {
      const { data } = await mongeService.queryDwgList(fileId, rvtVersion);
      const list = mongeApiMlib.assembleMapUrl(data, fileId);
      this.groupPics = [...this.groupPics, ...list].map(e => {
        return {
          ...e,
          uuid: uuidv4()
        };
      });
    },

    selectMap(selection, row) {
      this.loadList = selection;
      if (selection.length > 1) {
        this.$message.warning("暂时只能叠一张图");
        return;
      }
      if (selection.some(e => e.uuid === row.uuid)) {
        this.drawModelOverlay(row);
      } else {
        this.unloadDrawing(row, selection.length);
      }
    },
    // 开始叠图
    async drawModelOverlay(data) {
      let drawing = {};
      if (this.mlibEnabled) {
        const spaceWithDetailItems = await this.dealIsOssUrl(data);
        drawing = await mongeApiMlib.startModelOverlay(spaceWithDetailItems);
      } else {
        const { picsurl } = data;
        drawing = await mongeApiMlib.startModelOverlay(picsurl);
      }
      await mongeApiMlib.startDrawing(drawing);
      drawing.uuid = data.uuid;
      this.drawingList.push(drawing);
    },
    sectionLocation(val) {
      mongeApiMlib.setSection(val.sliderLocation);
    },
    // 卸载叠图
    async unloadDrawing(data, length) {
      const drawing = this.drawingList.find(e => e.uuid === data.uuid);
      await mongeApiMlib.unloadModelDrawing(drawing);
      this.drawingList = this.drawingList.filter(e => e.uuid !== data.uuid);
      if (length === 0) {
        mongeApiMlib.closeModelOverlay();
      }
    },
    // 处理isoss的url
    async dealIsOssUrl(data) {
      const { drawName, modelId } = data;
      const list = await mongeApiMlib.getModels().find(e => e.id === modelId).url?.bimexDetailList;
      const url = list.filter(item => item.drawName === drawName && item.label === '2D');
      const bimexDetailList = [];
      url.forEach(e => {
        if (!e.drawName) return;
        const bimexItemFile = {
          originFileName: e.lightFileName,
          url: e.downloadUrl,
          fileId: e.fileId
        };
        bimexDetailList.push(bimexItemFile);
      });
      return {
        bimexId: drawName,
        bimexName: drawName,
        convertFilePathId: drawName,
        bimexDetailList,
        sliderLocation: this.min + 5
      };
    },
    async changeOper() {
      this.operShow = !this.operShow;
      await this.$nextTick();
      if (!this.operShow) {
        this.loadList.forEach(row => {
          this.$refs.mapTable.toggleRowSelection(row, true);
        });
      }
    },
    maxValue() {
      return mongeApiMlib.getbboxmax();
    },
    minValue() {
      return mongeApiMlib.getbboxmin();
    },
    miniCom() {
      this.$emit('closeCom', 'modelOverlay', true);
    },
    async closeAdd() {
      this.drawingList.forEach(async drawing => {
        await mongeApiMlib.unloadModelDrawing(drawing);
      });
      this.$emit('closeCom', 'modelOverlay', false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#modelMap {
  position: fixed;
  top: 65px;
  left: 151px;
  width: 550px;
  height: calc(100% - 190px);
  max-height: 770px;
  .nav {
    height: 42px;
    padding: 7px 14px;
  }
  .list {
    width: 100%;
    height: calc(100% - 82px);
    padding: 0 18px;
    overflow-y: auto;
    /deep/ .el-table__header-wrapper .el-checkbox {
      display: none;
    }
  }
}
#modelMapMini{
  width: 460px;
  background: #fff;
  height: 200px;
  position: absolute;
  bottom: 95px;
  right: 10px;
  overflow: hidden;
  z-index: 5;
  .title{
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    background: #c7d0e1;
    border-bottom: 1px solid #DCE1ED;
    >span{
      margin-right: auto;
    }
    .el-button{
      margin-right: 10px;
    }
    i{
      cursor: pointer;
    }
  }
  .tableMin{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 10px;
    overflow-y: auto;
  }
  .verSlider{
    margin-left: 10px;
    width: 180px;
  }
}
</style>
